export * as Api from './api';
export var FeeAccounting;
(function (FeeAccounting) {
    FeeAccounting["ChargedToInvestor"] = "CHARGED_TO_INVESTOR";
    FeeAccounting["Accrued"] = "ACCRUED";
})(FeeAccounting || (FeeAccounting = {}));
export var FeeChargingFrequency;
(function (FeeChargingFrequency) {
    FeeChargingFrequency["Monthly"] = "MONTHLY";
    FeeChargingFrequency["Yearly"] = "YEARLY";
    FeeChargingFrequency["Quarterly"] = "QUARTERLY";
})(FeeChargingFrequency || (FeeChargingFrequency = {}));
export var FeeType;
(function (FeeType) {
    FeeType["Initial"] = "INITIAL";
    FeeType["Recurring"] = "RECURRING";
    FeeType["Commission"] = "COMMISSION";
    FeeType["Performance"] = "PERFORMANCE";
    FeeType["Fee"] = "ONE OFF FEE";
    FeeType["Discount"] = "ONE OFF DISCOUNT";
    FeeType["Adviser"] = "ADVISER";
    FeeType["Transaction"] = "TRANSACTION";
    FeeType["Withdrawal"] = "WITHDRAWAL FEE";
    FeeType["InvestorDiscount"] = "INVESTOR_DISCOUNT";
})(FeeType || (FeeType = {}));
export var FeeCalculationBasis;
(function (FeeCalculationBasis) {
    FeeCalculationBasis["Fixed"] = "FIXED";
    FeeCalculationBasis["PercentageOfTotalCommitment"] = "PERCENTAGE";
    FeeCalculationBasis["PercentageOfUnrealisedAssetCost"] = "PERCENTAGE_UAC";
})(FeeCalculationBasis || (FeeCalculationBasis = {}));
export var CoreFeeType;
(function (CoreFeeType) {
    CoreFeeType["InitialPercentage"] = "INITIAL %";
    CoreFeeType["RecurringPercentage"] = "RECURRING %";
    CoreFeeType["InitialFixed"] = "INITIAL \u00A3";
    CoreFeeType["RecurringFixed"] = "RECURRING \u00A3";
})(CoreFeeType || (CoreFeeType = {}));
export var FeeHurdleBasis;
(function (FeeHurdleBasis) {
    FeeHurdleBasis["Company"] = "COMPANY";
    FeeHurdleBasis["Investment"] = "INVESTMENT";
})(FeeHurdleBasis || (FeeHurdleBasis = {}));
export var PaymentEmailStatus;
(function (PaymentEmailStatus) {
    PaymentEmailStatus["UnpaidEmail"] = "UNPAID_EMAIL";
    PaymentEmailStatus["UnpaidPaymentReminderEmail"] = "UNPAID_PAYMENT_REMINDER_EMAIL";
    PaymentEmailStatus["UnpaidNoEmail"] = "UNPAID_NO_EMAIL";
    PaymentEmailStatus["UnpaidDisableEmail"] = "UNPAID_DISABLE_EMAIL";
    PaymentEmailStatus["PaidEmail"] = "PAID_EMAIL";
    PaymentEmailStatus["PaidNoEmail"] = "PAID_NO_EMAIL";
    PaymentEmailStatus["PaidDisableEmail"] = "PAID_DISABLE_EMAIL";
})(PaymentEmailStatus || (PaymentEmailStatus = {}));
export var InvestmentPaymentStatus;
(function (InvestmentPaymentStatus) {
    InvestmentPaymentStatus["FullyFunded"] = "FULLY_FUNDED";
    InvestmentPaymentStatus["PartiallyFunded"] = "PARTIALLY_FUNDED";
    InvestmentPaymentStatus["NoPayment"] = "NO_PAYMENT";
})(InvestmentPaymentStatus || (InvestmentPaymentStatus = {}));
export var InvestmentSource;
(function (InvestmentSource) {
    InvestmentSource["Transfer"] = "transfer";
    InvestmentSource["Upload"] = "upload";
    InvestmentSource["Further"] = "further";
})(InvestmentSource || (InvestmentSource = {}));
export var EisWizardInvestmentEnum;
(function (EisWizardInvestmentEnum) {
    EisWizardInvestmentEnum["Eis"] = "EIS";
    EisWizardInvestmentEnum["Seis"] = "SEIS";
})(EisWizardInvestmentEnum || (EisWizardInvestmentEnum = {}));
export var InvestmentCompletionStatus;
(function (InvestmentCompletionStatus) {
    InvestmentCompletionStatus["All"] = "ALL";
    InvestmentCompletionStatus["Completed"] = "COMPLETED";
    InvestmentCompletionStatus["Incomplete"] = "INCOMPLETE";
})(InvestmentCompletionStatus || (InvestmentCompletionStatus = {}));
export var InvestmentArchiveStatus;
(function (InvestmentArchiveStatus) {
    InvestmentArchiveStatus["All"] = "all";
    InvestmentArchiveStatus["NotArchived"] = "not_archived";
    InvestmentArchiveStatus["Archived"] = "archived";
})(InvestmentArchiveStatus || (InvestmentArchiveStatus = {}));
export var InvestmentCustomTagCategory;
(function (InvestmentCustomTagCategory) {
    InvestmentCustomTagCategory["Source"] = "source";
    InvestmentCustomTagCategory["InternalContact"] = "internal_contact";
    InvestmentCustomTagCategory["Other"] = "other";
})(InvestmentCustomTagCategory || (InvestmentCustomTagCategory = {}));
export var InvestorTag;
(function (InvestorTag) {
    InvestorTag["RequiresHardCopyReports"] = "requiresHardCopyReports";
    InvestorTag["VulnerableClient"] = "isVulnerableClient";
    InvestorTag["Deceased"] = "isDeceased";
})(InvestorTag || (InvestorTag = {}));
//# sourceMappingURL=index.js.map